import axiosAdmin from '../services/axiosAdmin';

// ---- Recebimentos / fila de conferência
export const obterResumo = () => axiosAdmin.get('/tributos/resumo').then(r => r.data);

export const pesquisarRecebimentos = params => axiosAdmin.get('/tributos/recebimento', { params }).then(r => r.data);

export const listarClientesRecebimento = () => axiosAdmin.get('/tributos/recebimento/clientes').then(r => r.data);

// Planilha Excel de conferência (o arquivo é gerado/lido no navegador)
export const exportarPlanilhaRecebimentos = params => axiosAdmin.get('/tributos/recebimento/exportar', { params }).then(r => r.data);
export const importarPlanilhaRecebimentos = itens => axiosAdmin.post('/tributos/recebimento/importar', { itens }).then(r => r.data);

// Alteração rápida de NCM: { ids, ncm, cest?, limparCest? } -> { quantidade }
export const alterarNcmRecebimentos = dados => axiosAdmin.put('/tributos/recebimento/alterarncm', dados).then(r => r.data);
export const alterarNcmProdutos = dados => axiosAdmin.put('/tributosproduto/alterarncm', dados).then(r => r.data);

export const obterRecebimento = id => axiosAdmin.get(`/tributos/recebimento/${id}`).then(r => r.data);

export const conferirRecebimento = (id, tributos, observacao) => axiosAdmin
  .put(`/tributos/recebimento/${id}/conferir`, tributos, { params: { observacao: observacao || undefined } })
  .then(r => r.data);

export const ignorarRecebimento = (id, observacao) => axiosAdmin
  .put(`/tributos/recebimento/${id}/ignorar`, null, { params: { observacao: observacao || undefined } })
  .then(r => r.data);

// Conferência em lote: { ids, tributos, manterNcmCest, observacao } -> { conferidos, jaBaixados, erros: [{ id, descricao, mensagem }] }
export const conferirLoteRecebimentos = lote => axiosAdmin.put('/tributos/recebimento/conferirlote', lote).then(r => r.data);

export const reabrirRecebimento = id => axiosAdmin.put(`/tributos/recebimento/${id}/reabrir`).then(r => r.data);

// ---- Base de tributos (TributosProduto)
export const pesquisarProdutos = params => axiosAdmin.get('/tributosproduto', { params }).then(r => r.data);

export const obterProduto = id => axiosAdmin.get(`/tributosproduto/${id}`).then(r => r.data);

export const incluirProduto = (dto, conferir = false) => axiosAdmin
  .post('/tributosproduto', dto, { params: conferir ? { conferir: true } : undefined })
  .then(r => r.data);

export const atualizarProduto = (id, dto) => axiosAdmin.put(`/tributosproduto/${id}`, dto).then(r => r.data);

export const conferirProduto = (id, dto) => axiosAdmin.put(`/tributosproduto/${id}/conferir`, dto).then(r => r.data);

// Importação da planilha da Base de tributos (linhas marcadas como conferidas)
export const importarPlanilhaProdutos = itens => axiosAdmin.post('/tributosproduto/importar', { itens }).then(r => r.data);

export const desmarcarConferido = id => axiosAdmin.put(`/tributosproduto/${id}/desmarcarconferido`).then(r => r.data);

export const excluirProduto = id => axiosAdmin.delete(`/tributosproduto/${id}`);

// ---- Alteração em massa por NCM
export const resumoNcm = ncm => axiosAdmin.get(`/tributosproduto/ncm/${ncm}`).then(r => r.data);

export const aplicarNcm = (ncm, dto, marcarConferido, ids) => axiosAdmin
  .put(`/tributosproduto/ncm/${ncm}`, dto, { params: { marcarConferido, ids: ids && ids.length ? ids.join(',') : undefined } })
  .then(r => r.data);

// ---- Tabelas auxiliares já existentes no backend
const listar = (recurso, params) => axiosAdmin.get(`/${recurso}`, { params }).then(r => r.data || []);

export const tabelas = {
  cst: () => listar('cst'),
  csosn: () => listar('csosn'),
  pisCofins: () => listar('piscofins'),
  origem: () => listar('origemmercadoria'),
  modalidadeBc: () => listar('icmsmodalidadebc'),
  modalidadeBcSt: () => listar('icmsmodalidadebcst'),
  classTribIBSCBS: () => listar('classtribibscbs'),
  classTribIS: () => listar('classtribis'),
};

export const buscarNcm = codigo => listar('ncm', { codigo });
export const buscarCest = codigo => listar('cest', { codigo });

/** Extrai a mensagem de erro no padrão MensagemErro { errors: [] } do backend. */
export function mensagemErro(error, padrao = 'Não foi possível concluir a operação.') {
  const data = error && error.response && error.response.data;
  if (data && Array.isArray(data.errors) && data.errors.length) return data.errors.join(' ');
  if (typeof data === 'string' && data.trim()) return data;
  if (error && error.response && error.response.status === 403) return 'Acesso não autorizado.';
  return padrao;
}
